export const DATE_ASYNC_FETCH = 'ITP_TravelDate/ASYNC_FETCH';
export const DATE_ASYNC_FETCH_SUCCESS = 'ITP_TravelDate/ASYNC_FETCH_SUCCESS';
export const DATE_ASYNC_FETCH_FAILURE = 'ITP_TravelDate/ASYNC_FETCH_FAILURE';
export const DATE_ASYNC_FETCH_INVALIDATE = 'ITP_TravelDate/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_TRAVEL_DATE = 'ITP_TravelDate/SET_SELECTED_TRAVEL_DATE';
/**
 * action types
 * @type {string}
 */

// export const formatDate = (val) => {
//   const value = new Date(val);
//   let dd = value.getDate();
//   let mm = value.getMonth() + 1; // January is 0!
//   const yyyy = value.getFullYear();
//   if (dd < 10) {
//     dd = '0' + dd;
//   }
//   if (mm < 10) {
//     mm = '0' + mm;
//   }

//   return mm + '/' + dd + '/' + yyyy;
// };
